
import ObjectCard from '../../components/Card/ObjectCard.vue'
import { getCustomTabsList } from './vehicleCardCustomTabs.js'

export default {
  extends: ObjectCard,
  data: function () {
    return {
      typeKeyLocal: 'vehicle' // @Override
    }
  },
  created: function () {
    if (this.small) {
      this.expandCardBtnHidden = true
    }
  },
  methods: {
    /**
     * ObjectCard
     */
    // @Override
    setObjectType: function (objectTypeKey) {
      // ignore Иначе typeKeyLocal перезапишется
    },
    // @Override
    getRawCustomTabsList: function (config) {
      const isMobile = this.$store.getters.getUser.view === 'mobile'
      config.small = this.small || isMobile
      return getCustomTabsList(config)
    },
    // @Default
    checkUserAccess: function (user, objectAssess) {
      const access = this.getDefaultAccess()
      access.editImage = objectAssess.editImage

      access.editPrivate = objectAssess.fullAccess
      access.viewPrivate = objectAssess.fullAccess
      access.viewPublic = true
      access.editPublic = objectAssess.editMainData
      access.editAny = access.editPublic || access.editImage
      return access
    }
  }
}
